<template>
  <section ref="cieloRaiz" class="modulo-cielo" aria-label="Homenaje desde el cielo">
    <div class="tarjeta-cielo">
      
      <h2 class="titulo-cielo">Desde lo mas alto <br>del Cielo</h2>

      <div class="foto-cielo-wrapper">
        <img src="@/assets/DSC00912.webp" class="foto-cielo" alt="Homenaje a Papá" />
      </div>

      <div class="dedicatoria-cielo">
        <p class="subtitulo-papa">Querido Papá:</p>
        <p class="frase-cielo">
          "Siempre estás en mi corazón, baila conmigo hoy."
        </p>
      </div>

    </div>
  </section>
</template><script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ModuloHomenajeCielo',
  setup() {
    const cieloRaiz = ref(null)

    onMounted(async () => {
      await nextTick()
      
      if (!cieloRaiz.value) return

      const $ = gsap.utils.selector(cieloRaiz.value)

      const tarjeta = $('.tarjeta-cielo')
      const titulo = $('.titulo-cielo')
      const fotoWrapper = $('.foto-cielo-wrapper')
      const textoHomenaje = $('.dedicatoria-cielo')

      // Timeline consecutiva con ScrollTrigger incorporado
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cieloRaiz.value,
          start: 'top 80%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      // 1. Aparece la tarjeta contenedora con el degradado celestial
      tl.fromTo(tarjeta, 
        { autoAlpha: 0, y: 50 },
        { autoAlpha: 1, y: 0, duration: 1 }
      )
      
      // 2. Entra el título manuscrito superior
      .fromTo(titulo,
        { autoAlpha: 0, y: -20 },
        { autoAlpha: 1, y: 0, duration: 0.8 },
        '-=0.5'
      )

      // 3. Revelado elegante de la foto central con escala y ligero desenfoque inicial
      .fromTo(fotoWrapper,
        { autoAlpha: 0, scale: 0.93, filter: 'blur(8px)', y: 30 },
        { autoAlpha: 1, scale: 1, filter: 'blur(0px)', y: 0, duration: 1.2 },
        '-=0.6'
      )

      // 4. Termina con los textos inferiores de la dedicatoria consecutivamente
      .fromTo(textoHomenaje,
        { autoAlpha: 0, y: 20 },
        { autoAlpha: 1, y: 0, duration: 0.8 },
        '-=0.4'
      )
    })

    return { cieloRaiz }
  }
}
</script>

<style scoped>
/* ==========================================================================
   CONTEGO GENERAL (SECCIÓN)
   ========================================================================== */
.modulo-cielo {
  width: 100%;
  display: flex;  background: linear-gradient(135deg, #df86af 0%, #cb428ed6 100%);

  justify-content: center;
  align-items: center;
  padding: 48px 16px;
  box-sizing: border-box;
}

/* ==========================================================================
   TARJETA CONTENEDORA (LOOK CELESTIAL)
   ========================================================================== */
.tarjeta-cielo {
  width: min(640px, 100vw);
  padding: 56px 24px 48px;
  text-align: center;
  border-radius: 32px;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  
  /* 🔥 DEGRADADO QUE EMULA EL ATARDECER DE TU CAPTURA */
  background: linear-gradient(180deg, #da70a0 0%, #f1b3c0 35%, #a8a4cb 75%, #c8e6f8 100%);
  
  /* Sombra sutil de lujo */
  box-shadow: 
    0 20px 48px rgba(143, 138, 183, 0.2),
    0 8px 20px rgba(0, 0, 0, 0.04);
}

/* Redondear esquinas interiores de la tarjeta en navegadores antiguos */
.tarjeta-cielo * {
  box-sizing: border-box;
}

/* ==========================================================================
   ELEMENTOS DE TEXTO (TÍTULOS Y FRASES)
   ========================================================================== */
.titulo-cielo {
  /* Usa tus fuentes globales cargadas, cayendo en cursive como respaldo */
  font-family: 'britishgruesa', 'titulos', 'Great Vibes', cursive;
  font-size: clamp(38px, 5.8vw, 66px) !important;
  color: #ffffff;
  font-weight: 400;
  margin: 0 0 32px 0;
  line-height: 1.15;
  letter-spacing: 0.5px;
  
  /* Suavizado de sombra para legibilidad sobre el rosa */
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
  will-change: transform, opacity;
}

.dedicatoria-cielo {
  padding: 0 6px;
  margin-top: 4px;
  will-change: transform, opacity;
}

.subtitulo-papa {
  font-family: 'Playfair Display', serif;
  font-size: clamp(18px, 2.6vw, 21px);
  color: #ffffff;
  font-weight: 600;
  margin: 0 0 8px 0;
  letter-spacing: 0.03em;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.frase-cielo {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: clamp(15px, 2.3vw, 18px);
  color: rgba(255, 255, 255, 0.96);
  line-height: 1.6;
  margin: 0;
  letter-spacing: 0.01em;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

/* ==========================================================================
   MARCO RECTANGULAR DE LA FOTO CENTRAL
   ========================================================================== */
.foto-cielo-wrapper {
  width: min(240px, 64vw);
  height: calc(min(240px, 64vw) * 1.33); /* Proporción aspecto fotográfico (3:4) */
  margin: 0 auto 32px;
  border-radius: 6px; /* Bordes rectos con un toque apenas suavizado igual a la captura */
  overflow: hidden;
  background: #ffffff;
  position: relative;
  z-index: 2;
  will-change: transform, filter, opacity;
  
  /* Sombra para despegar la foto del fondo de manera imponente */
  box-shadow: 
    0 16px 36px rgba(0, 0, 0, 0.22),
    0 4px 10px rgba(0, 0, 0, 0.1);
}

.foto-cielo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ==========================================================================
   RESPONSIVE (AJUSTES PANTALLAS CHICAS)
   ========================================================================== */
@media (max-width: 375px) {
  .tarjeta-cielo {
    padding: 44px 16px 36px;
    border-radius: 24px;
  }
  .titulo-cielo {
    font-size: 30px;
    margin-bottom: 24px;
  }
  .foto-cielo-wrapper {
    margin-bottom: 24px;
  }
}

/* Respetar preferencias del sistema (Accesibilidad) */
@media (prefers-reduced-motion: reduce) {
  .tarjeta-cielo,
  .titulo-cielo,
  .foto-cielo-wrapper,
  .dedicatoria-cielo {
    transition: none !important;
    animation: none !important;
  }
}
</style>